module.exports = __webpack_public_path__ + "static/media/BrutalType-Regular.4555758a.woff2";